import { render, staticRenderFns } from "./MaClassChangeGradeDialog.vue?vue&type=template&id=2940ea7c&scoped=true"
import script from "./MaClassChangeGradeDialog.vue?vue&type=script&lang=js"
export * from "./MaClassChangeGradeDialog.vue?vue&type=script&lang=js"
import style0 from "./MaClassChangeGradeDialog.vue?vue&type=style&index=0&id=2940ea7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940ea7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2940ea7c')) {
      api.createRecord('2940ea7c', component.options)
    } else {
      api.reload('2940ea7c', component.options)
    }
    module.hot.accept("./MaClassChangeGradeDialog.vue?vue&type=template&id=2940ea7c&scoped=true", function () {
      api.rerender('2940ea7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/MaClassDialog/MaClassChangeGradeDialog.vue"
export default component.exports